<template>
  <div class="console-container" ref='console-container'>
    <div ref='terminal' class="terminal-container" tabindex='-1'>
    </div>
    <div class="console-toolbox">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on='on' small text color="#FD971F" @click="cancel()">
            <v-icon>fas fa-ban</v-icon>
          </v-btn>
        </template>
        <span>Cancel</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on='on' small text color="#F92672" @click="reset()">
            <v-icon>fas fa-sync-alt</v-icon>
          </v-btn>
        </template>
        <span>Soft Reboot</span>
      </v-tooltip>
    </div>
  </div>
</template>


<script>
import { Terminal } from 'xterm'
import { FitAddon } from 'xterm-addon-fit';
require('xterm/css/xterm.css');
export default {
  name: 'Console',
  props: {
    height: String
  },
  data () {
    return {
      terminal: {
        type: Object,
        default: {}
      },
      term: null,
      mounted: false,
      line_buffer: "",
      fitAddon: null
    }
  },
  watch: {
    height:function() {
      this.resize();
    },
  },
  methods: {
    reset() {
      this.$emit('vterm-data', 0x03);
      this.$emit('vterm-data', 0x04);
    },
    cancel() {
      this.$emit('vterm-data', 0x03);
    },
    write(data) {
      this.term.write(data);
    },
    clear() {
      this.term.clear();
    },
    resize() {
      let that = this;
        window.requestAnimationFrame(function() {
          try {
            that.fitAddon.fit();
          } catch (e) {}
        });
    },
    toggleDarkMode(b) {
      this.term.setOption('theme', {
        background: b?'#272822':'#fff',
        foreground: b?'#c5c8c6':'#272822',
        selection: b?'#373b40':'#373b40',
        cursor: b?'#fc551f':'#fc551f',
        cursorAccent: b?'#c5c8c6':'#222'
      })
      Array.from(document.getElementsByClassName('terminal-container'))
      .concat(Array.from(document.getElementsByClassName('console-container')))
      .forEach(el=>el.style.backgroundColor=b?'#272822':'#fff');
    }
  },
  mounted () {
    if (!this.mounted) {
      this.term = new Terminal({
        minimumContrastRatio: 7,
        theme: {
          background: '#272822',
          foreground: '#c5c8c6',
          selection: '#373b40',
          cursor: '#fc551f',
          cursorAccent: '#c5c8c6'
        }
      });
      this.fitAddon = new FitAddon();
      this.term.loadAddon(this.fitAddon);
      this.term.onData(data=>{
        this.$emit('vterm-data', data);
      });
      this.term.open(this.$refs.terminal);
      this.fitAddon.fit();
      this.mounted = true;
      this.toggleDarkMode(true);
      console.log(this.term);
    }
  },
  beforeDestroy () {
    this.term.dispose();
  }
}
</script>

<style>
.xterm-viewport {
  max-height: 100% !important;
}
.terminal-container {
  height: 100%;
  outline: none;
}
.console-container {
  height: 100%;
  position: relative;
  float: left;
}
.console-toolbox {
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 9;
}
.console-plotter {
  position: absolute;
  left: 5px;
  top: 5px;
  bottom: 5px;
  right: 5px;
  z-index: 1;
}
</style>